import React, { useRef } from 'react';

import useMediaQuery from 'hooks/use-media-query';

import { useStoreLocatorContext } from '../../hooks';
import { StoreLocatorMap as MapContainer } from '../../map';
import useScrollToActiveStore from '../hooks/use-scroll-to-active-store';

import { Padding, SearchContainer, TabContainer } from './map-view.styled';

interface IMapViewProps {
  handleResetLocation: () => void;
  searchBarEl: JSX.Element;
  tabsEl: JSX.Element | false;
  tabPanelsEl: JSX.Element;
  nearbyStoreCardsEl: JSX.Element;
}

export const MapView: React.FC<IMapViewProps> = ({
  handleResetLocation,
  searchBarEl,
  tabsEl,
  tabPanelsEl,
  nearbyStoreCardsEl,
}) => {
  const isMobileFullScreen = useMediaQuery('mobileFullscreen');
  const isDesktop = useMediaQuery('desktop');

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const tabContainerRef = useRef<HTMLDivElement | null>(null);

  const {
    activeStoreId,
    nearbyStoreCardRefs,
    displayMapViewTabs,
    hasPanned,
    map,
    onClickSearch,
    zoom,
    currentViewIsMap,
  } = useStoreLocatorContext();

  // TODO: remove this whole hook once new UI feature rolls out
  //       or figure out a better way to decouple this beforehand
  useScrollToActiveStore({
    activeStoreId,
    nearbyStoreCardRefs,
    scrollContainerRef,
    tabContainerRef,
    canScroll: currentViewIsMap,
  });

  return (
    <>
      {!isDesktop && currentViewIsMap && searchBarEl}
      <MapContainer
        map={map}
        currentViewIsMap={currentViewIsMap}
        handleResetLocation={handleResetLocation}
        hasPanned={hasPanned}
        isDesktop={isDesktop}
        isMobileFullScreen={isMobileFullScreen}
        onClickSearch={onClickSearch}
        zoom={zoom}
      />
      {currentViewIsMap && (
        <SearchContainer ref={scrollContainerRef}>
          {isDesktop && <Padding>{searchBarEl}</Padding>}
          {displayMapViewTabs && !!tabsEl && (
            <div>
              <TabContainer ref={tabContainerRef}>{tabsEl}</TabContainer>
              <div>{tabPanelsEl}</div>
            </div>
          )}
          {!displayMapViewTabs && nearbyStoreCardsEl}
        </SearchContainer>
      )}
    </>
  );
};

export default MapView;
